export const colors = {
    backgroundPrimary: '#0D1117',
    backgroundSecondary: '#1E1E1E',
    textPrimary: '#FFFFFF',
    textSecondary: '#A0A0A0',
    accentPrimary: '#007AFF',
    accentSecondary: '#30D158', // A vibrant green for variety

    nBackground: "#161B22",


    // Old colors for reference, can be removed later
    // primary: '#3A405A',
    // secondary: '#AEC5EB',
    // accent: '#F9DEC9',
    // neutral: '#E9AFA3',
};
